import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {SearchWidgetThemeEnum} from '../../enums/search-widget-theme.enum';
import {WindowSizeService} from '../../../../services/window-size.service';
import {DLPageTypeEnum} from '../../../../enums/DataLayerEnums';

@Component({
  selector: 'app-search-widget-wrapper',
  templateUrl: './search-widget-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchWidgetWrapperComponent {
  theme = input<SearchWidgetThemeEnum>(SearchWidgetThemeEnum.DEFAULT);
  isOnTop = input<boolean>(false);
  mainCareProviderTypeId = input<number>();
  inferredCareProviderTypeAreaId = input<number>();
  inferredCategoryTypeId = input<number>();
  pageType = input<DLPageTypeEnum>();
  hideFiltersAndPlacePanel = input<boolean>();
  customCssClass = input<string>();

  private readonly mobileTreshold: number = 768;

  private windowSizeService = inject(WindowSizeService);
  private size = this.windowSizeService.windowSize;
  isMobile = computed<boolean>(() => this.size() && this.size()[0] < this.mobileTreshold);
}
